import SearchroomPanes from './SearchroomPanes'

// Body for a searchroom grid window. Renders the chat|PDF split once the room is
// available (fetched/cached by the page), or a loading placeholder while a
// persisted window rehydrates on reload.
function SearchroomWindowBody({ room, panes, onPanesChange }) {
  if (!room) {
    return <div className="display-empty">Loading searchroom…</div>
  }
  return <SearchroomPanes searchroom={room} panes={panes} onPanesChange={onPanesChange} />
}

export default SearchroomWindowBody
